import {AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, ViewChild} from '@angular/core';
import {decodeBlurHash} from "fast-blurhash";
import {FooterComponent} from "../footer/footer.component";
import {environment} from "../../../../environments/environment";
import {ChatVersions} from "../../../../../shared/chat.versions";
import {isInBrowser} from "../../../utils/clientutils";

@Component({
    selector: 'app-main-pages-container',
    imports: [
        FooterComponent
    ],
    templateUrl: './main-pages-container.component.html',
    styleUrls: ['../main.pages.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainPagesContainerComponent implements AfterViewInit {
    @ViewChild('canvas', {static: true}) canvas: ElementRef<HTMLCanvasElement>;
    @ViewChild('backgroundImage', {static: true}) backgroundImage: ElementRef<HTMLDivElement>;

    // Централизованная конфигурация путей к фоновым изображениям
    private readonly backgroundImageConfig = {
        vt: {
            1400: '/assets/vc_main_images/main_image_w_1400.webp',
            1299: '/assets/vc_main_images/main_image_w_1299.webp',
            915: '/assets/vc_main_images/main_image_w_915.webp',
            627: '/assets/vc_main_images/main_image_w_627.webp',
            200: '/assets/vc_main_images/main_image_w_200.webp'
        },
        sx: {
            1400: '/assets/sx_main_images/main_image_w_1400.webp',
            1299: '/assets/sx_main_images/main_image_w_1299.webp',
            915: '/assets/sx_main_images/main_image_w_915.webp',
            627: '/assets/sx_main_images/main_image_w_627.webp',
            200: '/assets/sx_main_images/main_image_w_200.webp'
        }
    };

    ngAfterViewInit() {
        if (!isInBrowser()) return

        if (document.readyState === 'complete') {
            // Страница уже полностью загружена
            this.setBackgroundImage();
        } else {
            if (this.canvas) {
                const rect = this.canvas.nativeElement.getBoundingClientRect();
                this.drawBlurImage(rect.width, rect.height);
            }

            // Загружаем фоновое изображение только после полной загрузки страницы
            this.waitForPageLoad();
        }
    }

    private waitForPageLoad() {
        if (!isInBrowser()) return
        window.addEventListener('load', () => {
            window.setTimeout(() => {
                this.loadBackgroundImage();
            }, 1000);
        }, {once: true});
    }

    private getNearestLargerMultipleOf100(width: number, height: number): number {
        const maxDimension = Math.max(width, height);
        return Math.ceil(maxDimension / 100) * 100;
    }

    private drawBlurImage(width: number, height: number) {
        const blurDimension = this.getNearestLargerMultipleOf100(width, height);
        //https://blurha.sh/
        const pixels = decodeBlurHash('|ZI;n:~q%hIos:RPRiWAa}-pM{S4bHxuRkWBn$ayR*WBRjt7R+R*aekCjZE1s:t6tRRjRPjZofofM{t7WBR*jZRjofj[j[aejtofR*ayaej[j[WBkCoLRjRkj[kCayj@WBj[WVjZa|WVf6WVayj[t7WBRkayj[oLayWBa|', blurDimension, blurDimension);
        const canvas = this.canvas.nativeElement;
        const ctx = canvas.getContext('2d');
        const imageData = ctx.createImageData(blurDimension, blurDimension);
        imageData.data.set(pixels);
        ctx.putImageData(imageData, 0, 0);

    }

    private loadBackgroundImage() {
        const img = new Image();

        img.onload = () => {
            // Устанавливаем background-image напрямую через JavaScript и добавляем анимацию
            this.setBackgroundImage()
        };

        img.onerror = () => {
            console.error('Failed to load background image');
        };

        img.src = this.getImageUrl();
    }

    private setBackgroundImage() {
        if (this.backgroundImage) {
            const imageUrl = this.getImageUrl()
            this.backgroundImage.nativeElement.style.backgroundImage = `url('${imageUrl}')`;
            this.backgroundImage.nativeElement.classList.add('background-loaded');
        }
    }

    private getImageUrl(): string {
        const width = isInBrowser() ? window.innerWidth : 1200;
        const imageType = environment.chatVersion == ChatVersions.VT ? 'vt' : 'sx';
        const config = this.backgroundImageConfig[imageType];

        if (width >= 1300) {
            return config[1400];
        } else if (width >= 916) {
            return config[1299];
        } else if (width >= 628) {
            return config[915];
        } else if (width >= 201) {
            return config[627];
        } else {
            return config[200];
        }
    }
}
